module.exports = __webpack_public_path__ + "static/media/SantaMonica.6dbf6a35.jpg";